import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ModalBase from '@/components/modalBase/modalBase';
import Loading from '@/components/loading/loading';
import { Action, Getter } from 'vuex-class';

@Component({
  components: {
    ModalBase,
    Loading
  }
})
export default class ModalSubscriptionDiscount extends Vue {

  @Prop({ default: false }) show;

  // Actions
  @Action action_updateSubscription;
  @Action action_applyDiscountCode;

  // Getters
  @Getter getSubscription;
  @Getter getCity;

  isLoading = false;
  coupon = {
    id: null,
    code: ""
  };

  inputValue = "";

  get isCouponApplied() {
    let response = false;
    if (
      this.getSubscription.subscription_discount &&
      this.getSubscription.subscription_discount.code
    ) {
      response = true;
    }
    return response;
  }

  mounted() {
    this._setInitialDiscount();
  }

  @Watch('getSubscription', { deep: true })
  _setInitialDiscount() {
    if (
      this.getSubscription &&
      this.getSubscription.subscription_discount &&
      this.getSubscription.subscription_discount.id &&
      this.getSubscription.subscription_discount.code
    ) {
      this.coupon = {
        id: this.getSubscription.subscription_discount.id,
        code: this.getSubscription.subscription_discount.code
      };
      this.inputValue = this.getSubscription.subscription_discount.code;
    } else {
      this.coupon = {
        id: null,
        code: ""
      };
      this.inputValue = "";
    }
  }

  async _applyCoupon() {
    if (this.inputValue !== "") {
      this.isLoading = true;
      try {
        let payload = null;
        let close = false;
        payload = {
          commerceId: this.getCity.id,
          subscriptionId: this.getSubscription.id
        };
        if (
          this.getSubscription.subscription_discount &&
          this.getSubscription.subscription_discount.code
        ) {
          payload.code = {
            code: ""
          };
          this.inputValue = "";
        } else {
          payload.code = {
            code: this.inputValue
          };
          close = true;
        }
        await this.action_applyDiscountCode(payload);
        close ? this.$emit('close') : false;
      } catch (error) {
        let msg = "";
        if (error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message;
        }
        this.$swal({
          title: "Error",
          text: `¡Ups! Hubo un error enviando la solicitud. ${msg}`
        });
      }
      this.isLoading = false;
    } 
  }
}
